var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VListItem',_vm._g(_vm._b({class:_vm.classList},'VListItem',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }